module.exports = __webpack_public_path__ + "static/media/thermometer.1ca453c9.svg";